"use client";

import * as React from "react"
import { motion } from "framer-motion"
import { useTranslations } from "next-intl"
import { cn } from "../../lib/utils"

export interface CreatorTrustRowProps extends React.HTMLAttributes<HTMLDivElement> {
  trustedByText?: string
  creatorsText?: string
  avatars?: string[]
}

const DEFAULT_AVATARS = [
  "/images/testimonial-akshata.jpg",
  "/images/testimonial-jobscampus.jpg",
  "/images/testimonial-ashish.png",
  "/images/testimonial-avinash.jpg",
  "/images/testimonial-thomasina.png"
]

export function CreatorTrustRow({
  className,
  trustedByText,
  creatorsText,
  avatars = DEFAULT_AVATARS,
  ...props
}: CreatorTrustRowProps) {
  const common = useTranslations("common")
  const resolvedTrustedByText = trustedByText ?? common("trustedBy")
  const resolvedCreatorsText = creatorsText ?? common("trustedCreatorsCount")

  return (
    <div
      className={cn(
        "flex items-center justify-center gap-2 text-xs font-medium text-[#475467]",
        className
      )}
      {...props}
    >
      <span>{resolvedTrustedByText}</span>
      <div className="flex -space-x-2.5">
        {avatars.map((avatar, idx) => (
          <motion.img
            key={idx}
            src={avatar}
            alt={`Creator ${idx + 1}`}
            className="w-10 h-10 rounded-full border-2 border-[#FFFAEF] object-cover ring-1 ring-black/5 cursor-pointer relative"
            whileHover={{
              scale: 1.3,
              zIndex: 10,
              rotate: idx % 2 === 0 ? 8 : -8,
              transition: { type: "spring", stiffness: 400, damping: 15 }
            }}
          />
        ))}
      </div>
      <span>
        <strong className="text-black font-semibold">{resolvedCreatorsText}</strong>
      </span>
    </div>
  )
}
